import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Newspaper, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";

export default function Blogg() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/publish/public/posts").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 animate-fade-in-up">
      <Seo
        title="Artiklar och guider om bygglov"
        description="Artiklar och guider om bygglov, PBL, BBR, attefall och kontrollansvarig från Bygglovskompassen."
        path="/blogg"
      />
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-blue-700 text-white flex items-center justify-center rounded-sm">
          <Newspaper className="w-6 h-6 stroke-[1.5]" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">Artiklar</div>
          <h1 className="text-3xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>Artiklar och guider</h1>
        </div>
      </div>

      {!posts ? (
        <div className="flex justify-center py-20"><Loader2 className="w-5 h-5 animate-spin text-zinc-500" /></div>
      ) : posts.length === 0 ? (
        <div className="mt-10 bg-zinc-50 border border-zinc-200 rounded-sm p-8 text-center text-sm text-zinc-600" data-testid="blogg-empty">
          Inga publicerade artiklar ännu – kika in snart igen!
        </div>
      ) : (
        <div className="mt-8 space-y-4" data-testid="blogg-list">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blogg/${p.slug}`} data-testid={`blogg-item-${p.slug}`}
              className="group block bg-white border border-zinc-200 hover:border-blue-300 rounded-sm p-6 transition">
              <div className="text-xs text-zinc-500">{(p.created_at || "").slice(0, 10)}</div>
              <h2 className="mt-1 text-lg font-semibold text-zinc-900 group-hover:text-blue-700 transition" style={{ fontFamily: "Outfit" }}>
                {p.title}
              </h2>
              {p.excerpt && <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{p.excerpt}</p>}
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-blue-700 font-medium">
                Läs artikeln <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition" />
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
